import BaseStore from 'vendor/cnpm/fluxible.v0-4/addons/BaseStore';

import Cue from 'bundles/interactive-transcript/models/Cue';
import Track from 'bundles/interactive-transcript/models/Track';

class VideoTranscriptStore extends BaseStore {
  static storeName = 'VideoTranscriptStore';

  static handlers = {
    RECEIVE_TRANSCRIPT(data: $TSFixMe) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'videoTranscript' does not exist on type ... Remove this comment to see the full error message
      this.videoTranscript = data;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'emitChange' does not exist on type '{ RE... Remove this comment to see the full error message
      this.emitChange();
    },
  };

  constructor(dispatcher: $TSFixMe) {
    super(dispatcher);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'videoTranscript' does not exist on type ... Remove this comment to see the full error message
    this.videoTranscript = null;
  }

  dehydrate() {
    return {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'videoTranscript' does not exist on type ... Remove this comment to see the full error message
      videoTranscript: this.videoTranscript,
    };
  }

  rehydrate(state: $TSFixMe) {
    if (!state.videoTranscript) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'videoTranscript' does not exist on type ... Remove this comment to see the full error message
      this.videoTranscript = null;
    } else {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'videoTranscript' does not exist on type ... Remove this comment to see the full error message
      this.videoTranscript = new Track();
      // Wrap with Cue class
      const cues = state.videoTranscript.cues.map((cue: $TSFixMe) => {
        return new Cue(cue.id, cue.index, cue.text, cue.startTime, cue.endTime);
      });
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'videoTranscript' does not exist on type ... Remove this comment to see the full error message
      Object.assign(this.videoTranscript, state.videoTranscript, { cues });
    }
  }

  hasLoaded() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'videoTranscript' does not exist on type ... Remove this comment to see the full error message
    return !!this.videoTranscript;
  }

  getData() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'videoTranscript' does not exist on type ... Remove this comment to see the full error message
    return this.videoTranscript;
  }
}

export default VideoTranscriptStore;
